export const FORM_CONTROL_HINT_SIZES = ['lg'] as const

export type FormControlHintSize = (typeof FORM_CONTROL_HINT_SIZES)[number]

export interface FormControlHintProps {
  tag?: string
  size?: FormControlHintSize
}
